import * as actionTypes from "./actionTypes";
import { swiftDayServices } from "../services/swiftDayServices.service";
import { swiftMessagesServices } from "../services/swiftMessagesServices.service";

export const resetSwiftDay = () => (dispatch) => {
  dispatch({
    type: actionTypes.RESET_SWIFT_DAY,
  });
};

export const getCorzapMessages = (data, error) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.LOAD_CORZAP_MESSAGES, payload: true });

    const res = await swiftDayServices.getCorzapMessages({
      ...data,
      direction: !!data?.direction ? data?.direction : null,
      type: data?.type === "All" ? "" : data?.type,
      fieldKey: data?.fieldKey === "All" ? "" : data?.fieldKey,
    });

    if (
      res.data.responseCode === "SUCCESS" ||
      res.data.responseCode === "LICENSE_WARNING"
    ) {
      dispatch({
        type: actionTypes.GET_CORZAP_MESSAGES,
        payload: res.data.returnObject,
      });
    } else if (res.data.responseCode === "VALIDATION_ERROR") {
      dispatch({
        type: actionTypes.GET_CORZAP_MESSAGES,
        payload: null,
      });

      error(res.data.message);
    }
  } catch (e) {
    error(e.message);
    dispatch({ type: actionTypes.LOAD_CORZAP_MESSAGES, payload: false });
  }
};

export const sendMail = (data, success, error) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.SENDING_MAIL, payload: true });

    const res = await swiftDayServices.sendMail(data);

    if (
      res.data.responseCode === "SUCCESS" ||
      res.data.responseCode === "LICENSE_WARNING"
    ) {
      success(res.data.message);
    } else if (res.data.responseCode === "VALIDATION_ERROR") {
      error(res.data.message);
    }

    dispatch({ type: actionTypes.SENDING_MAIL, payload: false });
  } catch (e) {
    error(e.message);
    dispatch({ type: actionTypes.SENDING_MAIL, payload: false });
  }
};

export const getBankLogoURL = (error) => async (dispatch) => {
  try {
    const res = await swiftDayServices.getBankLogoURL();

    if (
      res.data.responseCode === "SUCCESS" ||
      res.data.responseCode === "LICENSE_WARNING"
    ) {
      dispatch({
        type: actionTypes.SET_BANK_LOGO_URL,
        payload: res.data.returnObject,
      });
    } else if (res.data.responseCode === "VALIDATION_ERROR") {
      dispatch({
        type: actionTypes.SET_BANK_LOGO_URL,
        payload: null,
      });
      error(res.data.message);
    }
  } catch (error) {
    console.log(error);
    error(error.message);
  }
};

// SWIFT Messages
export const resetSwiftMessages = () => (dispatch) => {
  dispatch({
    type: actionTypes.RESET_SWIFT_MESSAGES,
  });
};

export const searchSwiftMessages = (data, error) => async (dispatch) => {
  try {
    dispatch({ type: actionTypes.SET_PROCESSING_SWIFT_MESSAGES });

    const res = await swiftMessagesServices.searchSwiftMessages({
      ...data,
      searchCriteria: {
        ...data.searchCriteria,
        direction: !!data.searchCriteria?.direction
          ? data.searchCriteria?.direction
          : null,
        type:
          data.searchCriteria?.type === "All" ? "" : data.searchCriteria?.type,
        fieldKey:
          data.searchCriteria?.fieldKey === "All"
            ? ""
            : data.searchCriteria?.fieldKey,
      },
    });

    if (
      res.data.responseCode === "SUCCESS" ||
      res.data.responseCode === "LICENSE_WARNING"
    ) {
      dispatch({
        type: actionTypes.SEARCH_SWIFT_MESSAGES,
        payload: {
          ...res.data.returnObject,
          pageNumber: data.pageNumber,
          pageSize: data.pageSize,
        },
      });
    } else {
      dispatch({
        type: actionTypes.SEARCH_SWIFT_MESSAGES,
        payload: null,
        error: res.data.message,
      });

      error(res.data.message);
    }
  } catch (err) {
    console.log(err);
    dispatch({
      type: actionTypes.SEARCH_SWIFT_MESSAGES,
      payload: null,
      error: err.message,
    });

    error(err.message);
  }
};

export const loadCounties = () => async (dispatch) => {
  try {
    const res = await swiftMessagesServices.getCountries();

    if (
      res.data.responseCode === "SUCCESS" ||
      res.data.responseCode === "LICENSE_WARNING"
    ) {
      dispatch({
        type: actionTypes.LOAD_COUNTRIES,
        payload: {
          ...res.data,
        },
      });
    } else if (res.data.responseCode === "VALIDATION_ERROR") {
      dispatch({
        type: actionTypes.LOAD_COUNTRIES,
        payload: null,
        error: res.data.message,
      });
      console.log(res.data.message);
    }
  } catch (error) {
    console.log(error);
  }
};

export const loadCurrencies = () => async (dispatch) => {
  try {
    const res = await swiftMessagesServices.getCurrencies();

    if (
      res.data.responseCode === "SUCCESS" ||
      res.data.responseCode === "LICENSE_WARNING"
    ) {
      dispatch({
        type: actionTypes.LOAD_CURRENCIES,
        payload: {
          ...res.data,
        },
      });
    } else if (res.data.responseCode === "VALIDATION_ERROR") {
      dispatch({
        type: actionTypes.LOAD_CURRENCIES,
        payload: null,
        error: res.data.message,
      });
      console.log(res.data.message);
    }
  } catch (error) {
    console.log(error);
  }
};

export const loadMessagesTypes = () => async (dispatch) => {
  try {
    const res = await swiftMessagesServices.getMessagesTypes();

    if (
      res.data.responseCode === "SUCCESS" ||
      res.data.responseCode === "LICENSE_WARNING"
    ) {
      dispatch({
        type: actionTypes.LOAD_MESSAGE_TYPES,
        payload: {
          ...res.data,
        },
      });
    } else if (res.data.responseCode === "VALIDATION_ERROR") {
      dispatch({
        type: actionTypes.LOAD_MESSAGE_TYPES,
        payload: null,
        error: res.data.message,
      });
    }
  } catch (error) {
    console.log(error);
  }
};

export const loadFieldNames = (messageTypeId) => async (dispatch) => {
  try {
    const res = await swiftMessagesServices.getFieldNames(messageTypeId);

    if (
      res.data.responseCode === "SUCCESS" ||
      res.data.responseCode === "LICENSE_WARNING"
    ) {
      dispatch({
        type: actionTypes.LOAD_FIELD_NAMES,
        payload: {
          ...res.data,
        },
      });
    } else if (res.data.responseCode === "VALIDATION_ERROR") {
      dispatch({
        type: actionTypes.LOAD_FIELD_NAMES,
        payload: null,
        error: res.data.message,
      });
    }
  } catch (error) {
    console.log(error);
  }
};
